module.exports = __webpack_public_path__ + "static/media/galerija_2017 (8).d47293cc.jpg";